import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-FlagDenmark-danmai",
  "use": "icon-FlagDenmark-danmai-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-FlagDenmark-danmai\"><defs><style type=\"text/css\"></style></defs><path d=\"M23.272727 186.181818h977.454546v651.636364H23.272727z\" fill=\"#B72F44\" p-id=\"2328\" /><path d=\"M23.272727 465.454545h977.454546v93.09091H23.272727z\" fill=\"#FFFFFF\" p-id=\"2329\" /><path d=\"M342.109091 186.181818h93.090909v651.636364h-93.090909z\" fill=\"#FFFFFF\" p-id=\"2330\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol